import React from 'react';

import { useUserStatusContext } from '../context/UserStatus';

type OrgStorageKeyOptions = {
    // Also namespace by the signed-in user. localStorage is per-browser-profile,
    // so shared workstations would otherwise leak preferences between agents.
    perUser?: boolean;
};

// Namespaces a localStorage key by the active organization so that a user's
// saved views / persisted filter selections don't leak across the orgs they can
// switch between. Falls back to 'default' before the active org resolves
// (initial load / single-org payload), which keeps single-org behaviour stable.
const useOrgStorageKey = ({ perUser = false }: OrgStorageKeyOptions = {}) => {
    const { activeOrgId, userStatus } = useUserStatusContext();
    const userId = userStatus?.hero_user_id;

    return React.useCallback(
        (key: string) => {
            const userScope = perUser ? `::user::${userId ?? 'default'}` : '';
            return `${key}${userScope}::org::${activeOrgId ?? 'default'}`;
        },
        [perUser, userId, activeOrgId]
    );
};

export default useOrgStorageKey;
